<template>
  <div class="relative w-full z-50">
    <!-- Search Input -->
    <input
        v-model="searchTerm"
        type="text"
        class="w-full p-2 border rounded"
        placeholder="Search hospitals..."
    />

    <!-- Dropdown List -->
    <ul
        v-if="filteredHospitals.length > 0"
        class="absolute w-full bg-white border rounded mt-1 max-h-48 overflow-y-auto shadow-lg z-50"
    >
      <li class="p-2 bg-green-200" @click="selectHospital(value)">{{ currentName }}</li>
      <li
          v-for="hospital in filteredHospitals"
          :key="hospital.hospital_id"
          class="p-2 hover:bg-gray-100 cursor-pointer"
          @click="selectHospital(hospital.hospital_id)"
      >
        {{ hospital.hospital_name }}
      </li>
    </ul>

    <!-- Loading Indicator -->
    <div
        v-else-if="hospitalsStore.isLoading"
        class="absolute w-full p-2 text-center text-gray-500 bg-gray-50"
    >
      <svg
          class="animate-spin h-8 w-8 text-blue-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
      >
        <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
        ></circle>
        <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        ></path>
      </svg>
    </div>

    <!-- No Results -->
    <div v-else class="absolute w-full p-2 text-center text-gray-500 bg-gray-50">
      No hospitals found.
    </div>
  </div>
</template>

<script>
import {useHospitalsStore} from '@/store/hospitals';

export default {
  name: 'HospitalSelector',
  props: ['params'],
  data() {
    return {
      searchTerm: '', // Local search term
      hospitalsStore: useHospitalsStore(), // Store instance
      value: this.params.value
    };
  },
  created() {
    this.value = this.params.value;
  },
  computed: {
    currentName() {
      // Get the name of the selected hospital
      const hospital = this.hospitalsStore.hospitals.find(
          (hospital) => hospital.hospital_id === this.value
      );
      return hospital ? hospital.hospital_name : '';
    },
    filteredHospitals() {
      return this.hospitalsStore.hospitals.filter((hospital) =>
          hospital.hospital_name
              .toLowerCase()
              .includes(this.searchTerm.toLowerCase()) && hospital.hospital_id !== this.value
      );
    },
  },
  methods: {
    selectHospital(hospital_id) {
      this.value = hospital_id;
      this.params.stopEditing();
    },
    isPopup: () => true,
    getValue() {
      return this.value;
    },
  },
};
</script>

<style scoped>
/* Add styles to improve dropdown appearance if needed */
</style>
